import React from 'react';
const CheckboxIcon = ({ customClass }) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", className: customClass },
        React.createElement("path", { d: "M3.34277 7.00006L5.93537 9.59266L11.1206 4.40747", stroke: "#121212", strokeWidth: "0.777778", strokeLinecap: "round", strokeLinejoin: "round" })));
};
export default CheckboxIcon;
